import styled from 'styled-components';

export const Container2 = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const SectionContainer = styled.div`
  padding: 40px 100px 0px 50px;
  display: flex;
  justify-content: space-evenly;
  height: max-content;

  @media screen and (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 40px 0px;
  }
`;

export const ImgContainer = styled.div`
  width: 65%;
  height: 100%;
  & > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media screen and (max-width: 900px) {
    width: 90%;
  }
`;

export const VideoTitle = styled.div`
  margin: 10px 0px;
  padding: 20px 0px 0 60px;

  & > h1 {
    margin: 0px;
    color: #555555;
    font-size: 1.9rem;
    font-weight: lighter;
  }
  & > h2 {
    margin: 0px;
    color: #55555540;
    font-size: 1.4rem;
    font-weight: lighter;
  }
`;

export const VideoList = styled.div`
  width: 30%;
  height: 100%;
  margin: 0px 0px 0px 40px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

  @media screen and (max-width: 900px) {
    width: 95%;
    margin: 10% 0px;
    border-radius: 0px;
  }
`;

export const HeaderList = styled.div`
  background: rgb(81, 153, 187);
  background: linear-gradient(
    90deg,
    rgba(81, 153, 187, 1) 22%,
    rgba(83, 103, 180, 1) 100%
  );
  border-radius: 15px 15px 0px 0px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

  @media screen and (max-width: 900px) {
    border-radius: 0px;
    text-align: center;
  }
`;

export const Title = styled.div`
  padding: 25px 0 25px 25px;
  & > h1 {
    margin: 0;
    color: #ffff;
    font-size: 1.2rem;
  }
  @media screen and (max-width: 900px) {
    padding: 10px 0px;
  }
`;

export const Text = styled.div`
  display: flex;
  justify-content: space-evenly;
  border-top: 1px solid #ffff;
  & h5 {
    margin: 0px 0px 0px 0px;
    padding: 5px 0px 5px 0px;
    color: #ffff;
  }
  & > div {
    width: 50%;
    text-align: center;
    transition: all 0.3s ease-in-out;
    color: #ffff;
    cursor: pointer;
  }

  & > div:hover {
    background-color: #ffff;
    color: #fdfdfd;
  }
`;

export const List = styled.div`
  height: 450px;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 0 0 15px 15px;
  background-color: #fff;
  padding: 4px 0;

  /* Scrollbar personalizada mejorada */
  &::-webkit-scrollbar {
    width: 8px;
    background: transparent;
  }

  &::-webkit-scrollbar-track {
    background: #f1f3f4;
    border-radius: 10px;
    margin: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #1976d2 0%, #1565c0 100%);
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;

    &:hover {
      background: linear-gradient(180deg, #1565c0 0%, #1e88e5 100%);
      transform: scaleX(1.2);
    }

    &:active {
      background: linear-gradient(180deg, #0d47a1 0%, #1976d2 100%);
    }
  }

  &::-webkit-scrollbar-corner {
    background: transparent;
  }

  /* Scroll behavior suave */
  scroll-behavior: smooth;
  
  /* Estilos para Firefox */
  scrollbar-width: thin;
  scrollbar-color: #1976d2 #f1f3f4;
`;

export const ButtonSection = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 10px 110px 0px 0px;
  & > h2 {
    color: ${(props) => props.theme.colors.titleBlue};
    margin: 0px 10px 0px 0px;
    font-size: 1.3rem;
  }
`;
